// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NavigationMenu_wrapper__7lVmP","mainLogo":"NavigationMenu_mainLogo__h19KD","link":"NavigationMenu_link__kRc88","headerMenu":"NavigationMenu_headerMenu__WPD29"};